import { BRAND, MARK_D, MARK_RADIUS, lockupGeometry } from '../../../src/brand/logo';
import { WORDMARK } from '../../../src/brand/wordmark';

// The Outlevo logo in the app (src/brand/logo.ts is the one source; the brand guide is
// Outlevo-Feature-Specifications/Brand: logo and share images.md): the green tile keeps its colours in both themes,
// the wordmark follows the text colour.

const Glyph = ({ color }: { color: string }) => <path d={MARK_D} stroke={color} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" fill="none" />;

/** The mark: the tick-arrow on the green tile. */
export function Mark({ className }: { className?: string }) {
  return <svg className={className} viewBox="0 0 32 32" aria-hidden="true"><rect width="32" height="32" rx={MARK_RADIUS} fill={BRAND.green} /><Glyph color={BRAND.paper} /></svg>;
}

/** The glyph alone in the current colour, for a ground that is already a tile (the assistant's avatar). */
export function MarkGlyph({ className }: { className?: string }) {
  return <svg className={className} viewBox="0 0 32 32" aria-hidden="true"><Glyph color="currentColor" /></svg>;
}

const G = lockupGeometry(32);
/** The lockup: the mark and "outlevo", drawn 32 units high (size it with CSS height). */
export function Logo({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox={`0 0 ${G.width} 32`} role="img" aria-label="Outlevo">
      <rect width="32" height="32" rx={MARK_RADIUS} fill={BRAND.green} /><Glyph color={BRAND.paper} />
      <path transform={`translate(${G.x} ${G.baseline}) scale(${G.scale})`} d={WORDMARK.d} fill="currentColor" />
    </svg>
  );
}
